var jade = require("C:\\Work\\David\\repo\\cartonomy-website\\Cartonomy-Website\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout-gt-sm=\"row\" layout=\"column\" layout-margin class=\"about-page content\"><div layout=\"column\" flex-gt-sm=\"60\" class=\"order\"><h1 text-center>{{'client.about.cartonomy' | translate}}</h1><div layout=\"column\" layout-wrap items=\"groups\" text-center><p class=\"small\">{{'client.about.version' | translate}}: {{ versionNumber }}</p><p class=\"small\">{{'client.about.build_date' | translate}}: {{ buildTime }}</p><p class=\"small\">{{'client.about.api_version' | translate}}: {{ serverVersion.version }}</p><p class=\"small\">{{'client.about.api_build_date' | translate}}: {{ serverVersion.buildTime }}</p></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/about/views/about.jade
// module id = 650
// module chunks = 0